<template>
  <div id="root">
    <router-view/>
    <div class="banner">
      <p>Activador</p>
      <p>De Promociones</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Root'
}
</script>

<style lang="scss">
  @import 'assets/icons/style.css';
</style>



// WEBPACK FOOTER //
// src/root.vue